// мы передаём сюда ID школы и названия кордао
import React from 'react';
import { AvatarPlate } from 'src/ver2/containers/lowlavel/avatarPlate'
import { withCapoeiraSportState } from 'src/ver2/context';
import { Link } from 'react-router-dom';

import SchoolAvatar from './avatar';

const SchoolPlate = (props) => {
    const { width, height, SchoolId, client, linkTo = 'default' } = props;

    const school = client.getSchoolById(SchoolId);

    if (linkTo)
        return <Link to={linkTo === 'default' ? `/school/${SchoolId}/info` : linkTo}>
            <AvatarPlate
                text={school ? school.Name : 'Нет школы'}
                width={width}
                height={height}
                AvatarComponent={SchoolAvatar}
                avatarComponentProps={{ schoolId: SchoolId }}
            />
        </Link>

    return <AvatarPlate
        text={school ? school.Name : 'Нет школы'}
        width={width}
        height={height}
        AvatarComponent={SchoolAvatar}
        avatarComponentProps={{ schoolId: SchoolId }}
    />

}

export default React.memo(withCapoeiraSportState('client')(SchoolPlate));